import { Component, Input, OnInit } from '@angular/core';
import { Asset } from '../../../../model/asset';
import { DeviceMeasurement } from '../../../../model/device-measurement';
import { DevicesService } from '../../../../services/devices.service';
import { AssetMeasurement } from '../../../../model/asset-measurement';
import { AssetsService } from '../../../../services/assets.service';

@Component({
  selector: 'app-asset-sensors',
  templateUrl: './asset-sensors.component.html',
  styleUrls: ['./asset-sensors.component.scss']
})
export class AssetSensorsComponent implements OnInit {

  @Input()
  public asset: Asset;

  public measurements: AssetMeasurement[];
  public totalMeasurements: number;
  public loadingMeasurements: boolean;

  public rows = 10;
  public first = 0;

  constructor(private assetsService: AssetsService) {}

  ngOnInit(): void {
    this.loadMeasurements();
  }

  private loadMeasurements(): void {
    this.loadingMeasurements = true;
    this.measurements = new Array(this.rows);
    this.assetsService.getAssetMeasurementsOfAsset(this.asset.uuid)
      .subscribe(response => {
        this.measurements = response.assetMeasurements;
        this.totalMeasurements = this.measurements.length;
        this.loadingMeasurements = false;
      });
  }

}
